import { CUIColors, SelectOptionTypes } from '@dotcom/crown-ui';

export type ObjectOrderProps = {
  /** Class to append to ObjectOrder component */
  addClass?: string;
  /** Component Children */
  children?: React.ReactNode;
  /** Function to be called when bring to front button is clicked */
  onBringToFront: () => void;
  /** Function to be called when send to back button  is clicked */
  onSendToBack: () => void;
  /** String to be used in the label of the bring to front button */
  bringToFrontLabel: string;
  /** String to be used in the label of the send to back button */
  sendToBackLabel: string;
};

export type FontStyleProps = {
  /** Class to append to FontStyle component */
  addClass?: string;
  /** Label string */
  label: string;
  /** List of the available fonts in the drawer */
  fonts: Font[];
  /** The id of the selected font */
  selectedFont: string;
  /** Function to fire when a selection is made */
  onChange?: (option: SelectOptionTypes) => void;
  /** Test ID string */
  testId?: string;
};

export type FontSizeProps = {
  /** Class to append to FontSize component */
  addClass?: string;
  /** Label string. Required. */
  label: string;
  /** Function to execute when a click is made on either the decrease or increase button. Required. */
  onClickButton: (param: string) => void;
  /** Test ID string. Required. */
  testId: string;
  /** Size value of the Font. Required. */
  fontSizeValue: number;
  /** Maximum number for the Font Size. Required. */
  upper: number;
  /** Minimum number for the Font Size. Required. */
  lower: number;
};

export type ColorOptionProps = {
  /** Class to append to TextColorDrawer component */
  addClass?: string;
  /** When true, renders colors in a single horizontally scrollable row (mobile) */
  scrollable?: boolean;
  /** List of custom colors */
  colors: string[];
  /** Current Selected color, this should be handled by the parent component with a state */
  selectedColor: string;
  /** Function to be executed when a button (in this case a color) is clicked */
  buttonGroupClick: (colorName: string) => void;
  /** Accessible name for the colour group listbox — always required, independent of visible label */
  ariaLabel: string;
  /** Visible label rendered above the swatches; omit to hide the label without losing accessibility */
  label?: string;
  /** Color to be shown in the label */
  labelColor?: CUIColors;
  /** Test id to be used in the component */
  testId?: string;
};

export type AlignmentProps = {
  /** Class to append to Alignment component */
  addClass?: string;
  /** Label string */
  label: string;
  /** The function that fires on button click. Required. */
  buttonGroupClick: (e: number) => void;
  /** The index of the active button */
  activeIndex: number;
};

/** Parameters to be sent on the onClickButton actions */
export enum FontSizeAction {
  Increase = 'increase',
  Decrease = 'decrease',
}

export type Font = {
  id: number;
  family: string;
  text: string;
};

export type FontDrawerFooterProps = {
  onCancel: () => void;
  onSubmit: () => void;
};

export type HexToColorMap = { [hexValue: string]: string };

export type FontSelectedOption = SelectOptionTypes & {
  id: number;
};
